import React, { Component } from "react";
import $ from 'jquery';

class ActivityVideo extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			showPause: false,
			videoDuration: '00:00',
			currentDuration: '00:00',
			durationWidth: 0,
			isMuted: false,
			videoDurationMain: 0
		}
		
		this.videoInterval = null;
	}
 
	componentDidMount(){
		this.getVideoDuration();
		this.videoControl('play');
	}
	
	videoDurationFormat=(duration)=>{
		 // Hours, minutes and seconds
		var hrs = ~~(duration / 3600);
		var mins = ~~((duration % 3600) / 60);
		var secs = ~~duration % 60;

		// Output like "1:01" or "4:03:59" or "123:03:59"
		var ret = "";

		if (hrs > 0) {
			ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
		}
		
		if ( mins.toString().length == 1 ) { mins = '0'+mins; }

		ret += "" + mins + ":" + (secs < 10 ? "0" : "");
		ret += "" + secs;
		return ret;
	}
	
	getVideoDuration=()=>{
		var videoMain = document.getElementById('workout_video');
		var mainthis = this;
		videoMain.onloadedmetadata = function(e){
			var duration = videoMain.duration;
			var finalDuration = mainthis.videoDurationFormat(duration);
			mainthis.setState({videoDuration: finalDuration, videoDurationMain: duration});
		}
	}
	
	videoControl=(par, videoSeconds)=>{
		var videoMain = document.getElementById('workout_video');
		
		var videoInterval;
		var mainthis = this;
		if ( par === 'play' )
			{
				videoMain.play();
				
				videoMain.oncanplay = function () { 
					$('#workout_video').removeClass('d-none');
					$('#video_controls').removeClass('d-none');
					$('#loading_video').addClass('d-none');
				};
				
				mainthis.setState({showPause: true});
				
				this.videoInterval = setInterval(function(){
					if ( videoMain.currentTime > -1  && !videoMain.ended && videoMain.readyState > 2 )
						{
							if ( videoSeconds ) 
								{ 
									videoMain.currentTime = videoSeconds; 
									videoSeconds = null;
								}
							
							var currentTime = mainthis.videoDurationFormat(videoMain.currentTime);
							var percent = (videoMain.currentTime / videoMain.duration * 100);
							mainthis.setState({currentDuration: currentTime, durationWidth: percent});
						}
					else
						{
							if ( videoMain.readyState > 1 )
								{
									mainthis.videoControl('stop');
									clearInterval(mainthis.videoInterval);
									mainthis.videoInterval = null;
									if ( videoMain.ended )
										{
											var duration = videoMain.duration;
											var finalDuration = mainthis.videoDurationFormat(duration);
											mainthis.setState({currentDuration: finalDuration, durationWidth: 100});
										}
								}
							
						}
				}, 500);
			}
		
		if ( par === 'pause' || par === 'stop' )
			{
				videoMain.pause();
				mainthis.setState({showPause: false});
				if ( this.videoInterval ) { clearInterval(this.videoInterval); this.videoInterval = null; };
				
				if ( par === 'stop' )
					{
						videoMain.currentTime = 0;
						mainthis.setState({currentDuration: '00:00', durationWidth: 0});
					}
			}
			
		if ( par === 'mute' ) 
			{
				var isMutedVar = mainthis.state.isMuted;
				isMutedVar = !isMutedVar;
				videoMain.muted = isMutedVar;
				mainthis.setState({isMuted: isMutedVar});
			}
		
	}
	
	closeVideo=()=>{
		$('#workout_video').addClass('d-none');
		$('#video_controls').addClass('d-none');
		$('#loading_video').removeClass('d-none');
		this.videoControl('stop');
		this.props.updateStateFromChild({openActivityVideo: false, videoURL: ''});
	}
	
	setVideoDuration=(e)=>{
		var rect = e.target.getBoundingClientRect();
		var x = e.clientX - rect.left; //x position within the element.
		var divWidth = $('#outerLine').width();
		var percentLine = (x / divWidth) * 100;
		var videoSeconds = (this.state.videoDurationMain * percentLine) / 100;
		
		if ( this.videoInterval )
			{
				clearInterval(this.videoInterval);
				this.videoInterval = null;
			}
		
		this.videoControl('play', videoSeconds);
	}
	
	render() {
		return (
			<div className="video_holder">
				<div className="close_video" onClick={() => this.closeVideo()}></div>
				<video className="activity_video d-none" id="workout_video" src={this.props.videoURL} type="video/mp4"></video>
				<div className="activity_video_loading" id="loading_video">Loading Video...</div>
				<div className="main_controls d-none" id="video_controls">
					{ !this.state.showPause &&
						<div className="play_work" onClick={() => this.videoControl('play')}></div>
					}
					{ this.state.showPause &&
						<div className="pause_work" onClick={() => this.videoControl('pause')}></div>
					}
					<div className="stop_work" onClick={() => this.videoControl('stop')}></div>
					<div className="mute_work" onClick={() => this.videoControl('mute')}>
						{ this.state.isMuted && <div className="muted_video"></div> }
					</div>
					<div className="line_video" id="outerLine" onMouseUp={this.setVideoDuration}>
						<div className="inner_line_video" style={{width: this.state.durationWidth+'%'}}></div>
					</div>
					<div className="video_duration">{this.state.currentDuration}/{this.state.videoDuration}</div>
				</div>
			</div>		
	)}
}
export default ActivityVideo;
